export { default as RequestCreateAttachmentFieldDumb } from './request-create-attachment-field-dumb';
